module.exports = __webpack_public_path__ + "static/58import-f654fc451e71598439d642d046d97161.png";